import { render } from "./fbx-input-reset.vue?vue&type=template&id=d36ec618&scoped=true"
import script from "./fbx-input-reset.vue?vue&type=script&lang=js"
export * from "./fbx-input-reset.vue?vue&type=script&lang=js"

import "./fbx-input-reset.vue?vue&type=style&index=0&id=d36ec618&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d36ec618"]])

export default __exports__